import type { ReactNode } from 'react';

import { ListingViewMainHolder } from './ListingViewMain.styled';

type Props = {
  children: ReactNode;
};

export function ListingViewMain({ children }: Props) {
  return <ListingViewMainHolder>{children}</ListingViewMainHolder>;
}
